import React from 'react';
import ReactDOM from 'react-dom';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Provider } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { App } from './App';
import { store, persistor } from './reducers';
import {PersistGate} from "redux-persist/integration/react";
import ErrorBoundary from './Components/ErrorBoundary';
import { normalizeTrackingParams } from './Utils/normalizeTrackingParams';

// MUST stay the first statement. Survey providers append their tracking params
// before the '#', where our hash routes cannot see them; this folds them into
// the hash route while the URL is still untouched — before HashRouter reads it
// in App.tsx and before any page component mounts.
normalizeTrackingParams();

library.add(fas);

// Dynamically load the Verisoul SDK if configuration variables are set
const loadVerisoulSDK = () => {
  if (document.getElementById('verisoul-sdk-script')) return;

  const projectId = process.env.REACT_APP_VERISOUL_PROJECT_ID;
  const env = process.env.REACT_APP_VERISOUL_ENV;

  if (!projectId || !env) {
    console.error('[Verisoul ERROR] REACT_APP_VERISOUL_PROJECT_ID or REACT_APP_VERISOUL_ENV is missing in .env');
    return;
  }

  const script = document.createElement('script');
  script.id = 'verisoul-sdk-script';
  script.async = true;
  script.src = `https://js.verisoul.ai/${env}/bundle.js`;
  script.setAttribute('verisoul-project-id', projectId);
  script.setAttribute('project_id', projectId);
  document.head.appendChild(script);
  console.log(`[Verisoul] SDK script injected for project ${projectId} in ${env} env.`);
};

// Execute load
loadVerisoulSDK();

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root'),
);
